import React, { Suspense, useEffect } from "react";
import { ErrorBoundary } from "./components";
import { useAuth } from "./context/auth-context";
import { FullPageSpinner } from "./components/lib";
import AuthenticatedApp from "./AuthenticatedApp";
import UnauthenticatedApp from "./UnauthenticatedApp";
import { useDebug } from "./context/debug-context";
import "./App.css";
import { LOCAL_STORAGE_KEY } from "./constants/localStorage";
import { DEBUG_FLAG } from "./constants/debug";

//const AuthenticatedApp = React.lazy(() => import('./AuthenticatedApp'))
//const UnauthenticatedApp = React.lazy(() => import('./UnauthenticatedApp'))

function App() {
  const { user } = useAuth();

  useEffect(() => {
    function handleKeyPress(event) {
      // You can put code here to handle the keypress.
      if (event.ctrlKey) {
        if (event.key === "+") {
          console.log("Zoom in");
          window.api?.send("asyncToMain", "zoomIn");
        } else if (event.key === "-") {
          console.log("Zoom out");
          window.api?.send("asyncToMain", "zoomOut");
        } else {
          //          console.log(event);
        }
      }
    }

    window.addEventListener("keyup", handleKeyPress, true);
    return () => {
      window.removeEventListener("keyup", handleKeyPress);
    };
  }, []);

  useEffect(() => {
    const lis = (e) => {
      if (!DEBUG_FLAG() && e.origin !== "https://pro.ectool.de") return;
      if (DEBUG_FLAG() && e.origin !== "http://localhost:3000") return;
      var data;
      try {
        if (typeof e?.data === "string") {
          data = JSON.parse(e?.data);
          if (data.accessToken) sessionStorage.setItem(LOCAL_STORAGE_KEY.accessToken, data.accessToken);
          if (data.formular) sessionStorage.setItem(LOCAL_STORAGE_KEY.formular, JSON.stringify(data.formular));
          if (data.userName) localStorage.setItem(LOCAL_STORAGE_KEY.username, data.userName);
          if (data.client) localStorage.setItem(LOCAL_STORAGE_KEY.client, data.client);
          if (data.theme) localStorage.setItem(LOCAL_STORAGE_KEY.theme, data.theme);

          // const hasToken = sessionStorage.getItem(LOCAL_STORAGE_KEY.accessToken);

          if (!user) {
            window.location.reload();
          } else {
            window.dispatchEvent(new Event("local-storage"));
            window.dispatchEvent(new Event("session-storage"));
          }
        }
      } catch (error) {
        console.log("Unknown message event", e);
      }
    };

    window.addEventListener("message", lis);

    return () => {
      window.removeEventListener("message");
    };
  }, []);

  return (
    <Suspense fallback={<FullPageSpinner />}>
      <ErrorBoundary errorComponent="app">{user ? <AuthenticatedApp /> : <UnauthenticatedApp />}</ErrorBoundary>
    </Suspense>
  );
}

export default App;
